import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';

import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { AbstractModal } from '~/component/modal/classes/abstract-modal';
import { ModalRoleEnum } from '~/component/modal/enums/role.enum';
import { ModalComponent } from '~/component/modal/modal.component';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertModalComponent extends AbstractModal {
  @Input() public autoClose = false;
  @Input() public closeLabel: string;
  @Input() public confirmLabel: string;
  @Input() public disabledConfirmButton = false;
  @Input() public hasCloseButton = false;
  @Input() public buttonVariant?: boolean;

  @Output() public readonly modalConfirm = new EventEmitter<boolean>();

  @ViewChild(ModalComponent) public modalComponent: ModalComponent;
  public readonly alertRole = ModalRoleEnum.AlertDialog;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public get variantButtonClose(): string {
    return this.vtmnPlayButtonVariant.SECONDARY;
  }

  public get variantButtonConfirm(): string {
    return this.buttonVariant
      ? this.vtmnPlayButtonVariant.PRIMARY
      : this.vtmnPlayButtonVariant.NEGATIVE;
  }

  public confirmModal(): void {
    this.modalConfirm.emit(true);
  }

  public hide(): void {
    this.modalComponent.hide();
  }

  public show(): void {
    this.modalComponent.show();
  }
}
